var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { cleanProps, getInputBaseProps } from './input.helpers';
export function useInputState(props, ref) {
    var _a = React.useState(props.value || props.initialValue), value = _a[0], setValue = _a[1];
    var _b = React.useState(props.error), error = _b[0], setError = _b[1];
    var _c = React.useState(props.errored), errored = _c[0], setErrored = _c[1];
    var _d = React.useState(false), isLoading = _d[0], setIsLoading = _d[1];
    return {
        value: value,
        setValue: setValue,
        error: error,
        setError: setError,
        errored: errored,
        setErrored: setErrored,
        inputProps: __assign(__assign({}, getInputBaseProps()), cleanProps(props)),
        initialState: {
            getRef: function () { return ref; },
            getValue: function () { return value; },
            getError: function () { return error; },
            setFocus: function () { var _a; (_a = ref.current) === null || _a === void 0 ? void 0 : _a['focus'](); },
            setLoading: function (v) { return setIsLoading(v); },
            setError: function (error) { setError(error); },
            setErrored: function (error) { setErrored(error); },
            isFilled: function () { return Boolean(value); },
            isFocused: function () { return document.activeElement === ref.current; },
            isReadonly: function () { return props.readOnly; },
            isDisabled: function () { return props.disabled; },
            isLoading: function () { return props.loading || isLoading; },
            isErrored: function () { return Boolean(props.error) || props.errored; },
            emitChange: function (value, event) {
                setValue(value);
                props.onChangeValue && props.onChangeValue(value);
                props.onChange && props.onChange(event);
            }
        }
    };
}
